import React from 'react';
import { useLocation } from "react-router-dom";
import Video from "../../main/Video";
import BackButton from '../../main/BackButton';


const MeaningOfDesign = (props) => {
    const location = useLocation();
    const { videoUrl } = location.state || {};
    return (
        <>
            <BackButton />
            <Video url={`${videoUrl}`} maxHeight="80%" />
        </>
    );
}
export default MeaningOfDesign;

